import { render, staticRenderFns } from "./inheritUsersList.vue?vue&type=template&id=5c9a4976&scoped=true&"
import script from "./inheritUsersList.vue?vue&type=script&lang=js&"
export * from "./inheritUsersList.vue?vue&type=script&lang=js&"
import style0 from "./inheritUsersList.vue?vue&type=style&index=0&id=5c9a4976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a4976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c9a4976')) {
      api.createRecord('5c9a4976', component.options)
    } else {
      api.reload('5c9a4976', component.options)
    }
    module.hot.accept("./inheritUsersList.vue?vue&type=template&id=5c9a4976&scoped=true&", function () {
      api.rerender('5c9a4976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/clientInherit/detail/inheritUsersList.vue"
export default component.exports